import { Component, OnInit } from '@angular/core';
import { DwMessage, DwMessageSeverity } from '@devwareapps/devware-cap';
import { AviatorLoginPageComponent } from '../aviator-login-page/aviator-login-page.component';

@Component({
  selector: 'app-aviator-registration-page',
  templateUrl: './aviator-registration-page.component.html',
  styleUrls: ['./aviator-registration-page.component.scss']
})
export class AviatorRegistrationPageComponent extends AviatorLoginPageComponent {


}
